import { Injectable } from '@angular/core';
import {
    IQueue,
    IQueueUpsert,
} from '@models';
import {
    FileDownloadService,
    QueueDefinitionService,
} from '@services';

@Injectable()
export class QueueUpsertPageService {

    constructor(
        private _queueService: QueueDefinitionService,
        private _downloadService: FileDownloadService,
    ) {}

    public getInstance = (id: number) =>
        this._queueService.getInstance(id)

    public add = (formValues: IQueueUpsert) =>
        this._queueService.add(formValues as IQueue)

    public update = (id: number, formValues: IQueueUpsert) =>
        this._queueService.update(id, {...formValues, id} as IQueue)

    public delete = (id: number) =>
        this._queueService.delete(id)

    public download = (id: number, type: string) =>
        this._downloadService.download(this._queueService.getDownloadSchemaJsonLink(id, type))
}
